<div class="container">
    <div class="container-table">
        <h1>
            GANADORES
        </h1>
        <div class="container-reslut">
            <span>
                Numero de premios entregados en el día<br>Cubrebocas: {{cubrebocas_today}} de {{data.cubrebocas.n}} | 10% de descuento: {{desc10_today}} de {{data.desc10.n}} | 15% de descuento: {{desc15_today}} de {{data.desc15.n}}
            </span>
        </div>
        <table>
            <tr *ngFor="let g of premios">
                <td>
                    {{g.date | date:'shortDate'}}
                </td>
                <td>
                    {{g.hour}}
                </td>
                <td>
                    {{serial}}
                </td>
                <td>
                    {{g.name}}
                </td>
            </tr>
        </table>
    </div>
</div>
<a (click)="goToHome()">
    <div class="text-2-container">
        <img class="arrow-right" src="../../assets/arrow-right.png" alt="logo">
        <span class="text-2">
            Regresar al inicio
        </span>
    </div>
</a>